<div class="content-heading">
  <div class="header-container">
    <h3>Reporte de Carátulas de Inventario</h3>
    <small>Reporte Web</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default shadow-sm border-0">
    <div class="card-body">
      
      <div class="row align-items-end">
        <div class="col-lg-3 col-md-4">
          <label class="font-weight-bold">Tipo</label>
          <select class="form-control" [(ngModel)]="type" (change)="cmbUnitChange($event.target.value)">
            <option [value]="1" [hidden]="userLogin?.Org === 2">CEVE</option>
            <option [value]="2">PLANTA</option>
          </select>
        </div>

        <div class="col-lg-6 col-md-8">
          <aph-custom-date-picker 
            [singleMode]="false" 
            labelInicio="Desde"
            labelFin="Hasta"
            [maxDate]="maxDate"
            mode="date"
            [IsDisabledAll]="downloading1 || downloading2 || downloading3"
            (startDateChange)="CalendarDesde = $event"
            (endDateChange)="CalendarHasta = $event"
            (onValidationStatus)="isValidRange = $event">
          </aph-custom-date-picker>
        </div>
      </div>

      <hr class="my-4">

      <div class="row">
        <div class="col-12 d-flex flex-wrap">
          
          <aph-custom-buttons 
            preset="excel" 
            label="Descargar Reporte Detalle" 
            [loading]="downloading1"
            [disabled]="!isValidRange"
            (btnClick)="download(1)"
            class="mr-2 mb-2">
          </aph-custom-buttons>

          <aph-custom-buttons 
            *ngIf="repDetallado"
            preset="excel" 
            label="Descargar Reporte Concentrado" 
            [loading]="downloading2"
            [disabled]="!isValidRange"
            (btnClick)="download(2)"
            class="mr-2 mb-2">
          </aph-custom-buttons>

          <aph-custom-buttons 
            *ngIf="repOrganizacional"
            preset="excel" 
            label="Descargar Reporte Organizacional" 
            [loading]="downloading3"
            [disabled]="!isValidRange"
            (btnClick)="download(3)"
            class="mr-2 mb-2">
          </aph-custom-buttons>

        </div>
      </div>

    </div>
  </div>
</div>